//authentification.js

//Passwords
//--------------------------------------------------------------------------------------
const passwords = [
	"123", 
	// "BGOpt", 
	"BUWOpt", 
	"Test123", 
	"Guest123", 
	"gaggenau", 
	"testzugang", 			
	"HSWOpt", 
	"BTUOpt",
	"FRAOpt", 
	"TUWOpt", 
	"DUAOpt",
	"WTMOpt", 
	"IBFOpt",
	"SPIOpt", 
	"PorrOpt", 
	"DMOpt", 
	"SNWOpt", 
	"EGSOpt"
];

const adminPasswords = [
	"Admin123",
	// "BGOpt_Admin"
];

//--------------------------------------------------------------------------------------
//This function checks if a user is authenticated
//--------------------------------------------------------------------------------------
function authenticateUser(password, user) {
	var result = false;

	const testUser = "test";

	if (passwords.includes(password.toString()) || adminPasswords.includes(password.toString())) {
		if (user == testUser) {
			result = true;
		// } else if (user.includes("@bollinger-grohmann")) {
		// 	result = true;
		} else if (user.includes("@kohlbecker")) {
			result = true;
		} else if (user.includes("@dietrich.untertrifaller.com")) {
			result = true;
		} else if (user.includes("@ajg-ing.de")) {
			result = true;
		} else if (user.includes("@wtm-hh.de")) {
			result = true;
		} else if (user.includes("@ib-federlein.de")) {
			result = true;
		} else if (user.includes("@hs-wismar.de")) {
			result = true;
		} else if (user.includes("@b-tu.de")) {
			result = true;
		} else if (user.includes("@fra-uas.de")) {
			result = true;
		} else if (user.includes("@uni-weimar.de")) {
			result = true;
		// } else if (user.includes("TU_Wien")) {
		// 	result = true;
		} else if (user.includes("@trees.no")) {
			result = true;
		} else if (user == "Timo") {
			result = true;
		} else if (user == "DDahinten") {
			result = true;
		} else if (user == "Gianluca") {
			result = true;
		} else if (user == "ricarda.fruehwirth@pde-porr.com") {
			result = true;
		} else if (user == "j.green@snw-ing.de"){
			result = true;
		} else if (user == "LADI@dortemandrup.dk") {
			result = true;
		} else if (user == "hermann.leis@egs-plan.de"){
			result = true;
		} else if (user == "M.Dombrowski@sbp.de") {
			result = true;
		}
	}

	return result;
}

//--------------------------------------------------------------------------------------
//This function checks if a user is an administrator -> can change database
//--------------------------------------------------------------------------------------
function authenticateAdmin(password, user) {
	var result = false;

	const testUser = "test";

	if (adminPasswords.includes(password.toString())) {
		if (user == testUser) {
			result = true;
		} else if (user.includes("@bollinger-grohmann.de")) {
			result = true;
		} else if (user.includes("@trees.no")) {
			result = true;
		}

		console.log("Admin from authenticateAdmin");
	}

	console.log("result from authenticateAdmin", result);

	return result;
}

//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------

export { authenticateUser, authenticateAdmin };
